export interface FileEvent {
	target: HTMLInputElement;
}

/** Exposes Chrome 76+ arrayBuffer() method */
export interface ModernFile extends File {
	arrayBuffer: () => Promise<ArrayBuffer>;
}

export enum DocumentTarget {
	Customer = 'Customer',
	Railroad = 'Railroad',
	Job = 'Job',
}
